const doc = [({"en":({"js":({"merfoto":({"photo_session_group_contacts":({"select_album":({"choose_album":"Choose album"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;